import React, { FunctionComponent, useEffect, useRef, useState } from "react";
import StarIcon from "@mui/icons-material/Star"; // Import a star icon from MUI
import "./ExamResult.scss";
import { useBlocker, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { listExamID } from "../../Redux/Slices/Exam/ListExamIDSlice";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import { Lightbulb, MessageSquare } from "lucide-react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  Label,
  Legend,
  Pie,
  PieChart,
  Rectangle,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import ButtonField from "../../Components/Button/ButtonField";
import { add, size } from "lodash";
import { listEvaluation } from "../../Redux/Slices/Exam/ListEvaluationSlice";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { listEvaluationPractice } from "../../Redux/Slices/PracticeExam/ListEvaluationPracticeSlice";
import { useLocation } from "react-router-dom";
import { listEvaluationPracticewritingExam } from "../../Redux/Slices/PracticeExam/ListEvaluationPracticewritingExamSlice";
import {
  Box,
  Typography,
  Paper,
  Grid,
  Modal,
  Divider,
  Card,
  Stack,
  LinearProgress,
  SvgIcon,
  AppBar,
  Toolbar,
  CircularProgress,
  useTheme,
  useMediaQuery,
  Container,
  Link,
  Avatar,
  AlertColor,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ChatIcon from "@mui/icons-material/Chat";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import AppBarnav from "../../Components/AppBar/AppBar";
import Loading from "../../Components/Loading/Loading";
import { clearListReViewExamIDPractice } from "../../Redux/Slices/ReViewExamPractice/ListReViewExamPracticeSlice";
import { Button, Chip } from "@mui/material";
import { themeUpdate } from "../../Redux/Slices/Theme/ThemeSlice";
import { ReactComponent as Logo } from "../../Assets/Images/loginlogo.svg";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import HomeIcon from "@mui/icons-material/Home";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ReactECharts from "echarts-for-react";
import InfoIcon from "@mui/icons-material/Info";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import difficultIcon from "./ImageExamPage/Group 1171276219.png";
import moderateIcon from "./ImageExamPage/Group 1171276220.png";
import easyIcon from "./ImageExamPage/Group 1171276221.png";
import start from "./ImageExamPage/Ellipse 188.png";
import greenball from "./ImageExamPage/Ellipse 189.png";
import Yellowball from "./ImageExamPage/Ellipse 190.png";
import Redball from "./ImageExamPage/star-01.png";
import { clearListReViewExamID } from "../../Redux/Slices/ReViewExam/ListReViewExamSlice";
import SubTypeTimeCharts from "./SubTypeTimeCharts";
import ChatbotExamEvaluation from "../../Components/ChatbotExamEvaluation/ChatbotExamEvaluation";
import AvatarImage from "../../Assets/Images/Chatbot_Avatar.png";
import { clearChatbotPublicStatus } from "../../Redux/Slices/ChatbotPublic/ChatbotPublicSlicer";
import { CustomSnackBox } from "../../Components/CustomSnackAlert/CustomSnackBox";
import { ReactComponent as DetailsStructure } from "../../Assets/Images/Details_Structure.svg";
import { ReactComponent as DetailsOverall } from "../../Assets/Images/Details_Overall.svg";
import { ReactComponent as DetailsLightbulb } from "../../Assets/Images/Details_Lightbulb.svg";
import { clearChatbotStatus } from "../../Redux/Slices/Chatbot/ChatbotSlicer";
import { clearReadChatbotPublicStatus } from "../../Redux/Slices/ChatbotPublic/ReadChatbotPublicSlicer";
import { clearWritingChatbotPublicStatus } from "../../Redux/Slices/ChatbotPublic/WritingChatbotPublicSlicer";
import { clearExamReadChatbotPublicStatus } from "../../Redux/Slices/ChatbotPublic/ExamReadChatbotPublicSlicer";
import { clearExamWritingChatbotPublicStatus } from "../../Redux/Slices/ChatbotPublic/ExamWritingChatbotPublicSlicer";
import { PerformanceCardProps } from "../../Components/Writing Result/IWritingResut";
import PerformanceComparisonCard from "../../Components/Writing Result/PerformanceComparisonCard";
import WritingStatsCard from "../../Components/Writing Result/WritingStatsCard";

interface ExamResultProps { }

type ShowAlertFunction = (
  severity: AlertColor,
  message: React.ReactNode,
  duration?: number
) => void;

interface QuestionTypeDetail {
  percentage_correct: number;
  question_type_id: number;
  question_type_name: string;
  subtypes: any | null;
  total_correct: number;
  total_count: number;
  total_time_spent: string;
  total_wrong: number;
}

function analyzeWritingWithTimeString(text: string, timeString: string | null) {
  const plainText = text.replace(/<\/?[^>]+>/g, "").trim();

  const words = plainText.split(/\s+/).filter((w) => w.length > 0);

  // Character count
  const charactersWithSpace = plainText.length;
  const charactersWithoutSpace = plainText.replace(/\s+/g, "").length;

  // Sentence calculation
  const sentences = plainText
    .split(/[.!?]+/)
    .filter((s) => s.trim().length > 0);

  // -------- FIXED PARAGRAPH LOGIC --------
  let paragraphs = 1;

  // Step 1: count real <p> blocks
  const pMatches = text.match(/<p[^>]*>([\s\S]*?)<\/p>/gi);

  if (pMatches && pMatches.length > 1) {
    paragraphs = pMatches.length;
  } else {
    // Step 2: detect internal paragraphs inside single <p>
    const contentInsideP = pMatches
      ? pMatches[0].replace(/<\/?p[^>]*>/gi, "") // remove <p>
      : plainText;

    const paraSplit = contentInsideP
      // detect <n> or newline-based paragraphs
      .split(/(<\/n>|<n>|\\n\\n|\n\s*\n)/gi)
      .filter(
        (para) =>
          para.trim().length > 0 && !["<n>", "</n>"].includes(para.trim())
      );

    console.log(paraSplit, "plainText → detected paragraphs");

    paragraphs = paraSplit.length > 0 ? paraSplit.length : 1;
  }

  // Optional: WPM calculation
  let wpm = null;
  let totalMinutes = 0;

  if (timeString) {
    const [h, m, s] = timeString.split(":").map(Number);
    const totalSeconds = h * 3600 + m * 60 + s;
    totalMinutes = totalSeconds / 60;
    wpm = totalMinutes > 0 ? Math.round(words.length / totalMinutes) : null;
  }

  return {
    words: words.length,
    charactersWithSpace,
    charactersWithoutSpace,
    sentences: sentences.length,
    paragraphs,
    totalMinutes,
    wpm,
  };
}

const ExamResult: FunctionComponent<ExamResultProps> = () => {
  const navigate = useNavigate();
  const location = useLocation(); // This gives you the current location object
  const query = new URLSearchParams(location.search);
  const { state } = location;
  const review_id = state?.id;

  const showSubmitAlertFromState = state?.showSubmitAlert || false;
  const id = query.get("id"); // Extract the 'id' parameter from the URL
  const Etype = query.get("type"); // Extract the 'type' parameter from the
  console.log(state, "result to");

  const dispatch = useAppDispatch();

  const { data: evaluationData, isLoading: EvaluationSlice } =
    useAppSelector((state) => state.ListEvaluationSlice);
  const {
    data: EvaluationPracticewritingExam,
    isLoading: PracticewritingExam,
  } = useAppSelector((state) => state.ListEvaluationPracticewritingExamSlice);

  const { isLoading: isSubmitting } = useAppSelector(
    (state) => state.ListExamsubmitSlice
  );
  const { isLoading: isAddingAnswer } = useAppSelector(
    (state) => state.AddExamAnswerSlice
  );
  const { isLoading: isEditingStudent } = useAppSelector(
    (state) => state.EditStudentExamSlice
  );

  const Add: any = evaluationData?.data;

  const isLoading =
    EvaluationSlice ||
    PracticewritingExam ||
    isSubmitting ||
    isAddingAnswer ||
    isEditingStudent;

  const hasDispatched = useRef(false);

  const percentage = Math.round(
    (Add?.total_correct / Add?.total_questions) * 100
  );
  const type = Etype || review_id?.type; // Use `Etype` if available, otherwise use `review_id?.type`

  // useEffect(() => {
  //   dispatch(
  //     listEvaluation({
  //       student_exam_id: id || review_id,
  //     })
  //   );
  // }, []);

  useEffect(() => {
    if (hasDispatched.current) return;

    if (isSubmitting || isAddingAnswer || isEditingStudent) {
      return;
    }

    const student_exam_id =
      review_id?.type === "Writing"
        ? review_id?.id
        : id
          ? Number(id)
          : review_id;
    const type = Etype || review_id?.type; // Use `Etype` if available, otherwise use `review_id?.type`

    // if (student_test_id) {

    dispatch(
      listEvaluation({
        student_exam_id: id || review_id,
      })
    );
    hasDispatched.current = true;

    // }
  }, [id, Etype, review_id, isSubmitting, isAddingAnswer, isEditingStudent, dispatch]);
  const student_exam_id =
    review_id?.type === "Writing" ? review_id?.id : id ? Number(id) : review_id;

  const timetaken = Add?.total_timing;
  let hours = 0,
    minutes = 0,
    seconds = 0; // Default values

  if (timetaken) {
    // Split the time string into hours, minutes, and seconds
    [hours, minutes, seconds] = timetaken
      .split(":")
      .map((part: any, index: number) =>
        index < 2 ? parseInt(part) : parseFloat(part)
      );
  }

  function formatTime(totalTime: any) {
    if (!totalTime || typeof totalTime !== "string") return "00h 00m 00s";

    const [hours = 0, minutes = 0, seconds = 0] = totalTime
      .split(":")
      .map((v) => parseInt(v, 10));

    return `${String(hours).padStart(2, "0")}h ${String(minutes).padStart(
      2,
      "0"
    )}m ${String(Math.round(seconds)).padStart(2, "0")}s`;
  }

  const formattedTime = `${formatTime(Add?.total_timing)}`;

  // Mock feedback and score

  // const updatedList: any = EvaluationPracticewritingExam?.data?.map(
  //   (item: any) => {
  //     return {
  //       ...item,
  //     };
  //   }
  // );

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // chatlist
  const totalQuestions = 37;
  const correct = 16;
  const incorrect = 5;
  const skipped = 16;

  // Sample time spent per question
  // const times = Array.from({ length: 37 }, (_, i) =>
  //   Math.floor(Math.random() * 60 + 10)
  // );

  // Define result types (e.g., correct/incorrect/skipped) per question
  type ResultType = "correct" | "incorrect" | "skipped";

  // Strongly type the colors object
  const colors: Record<ResultType, string> = {
    correct: "#22c55e",
    incorrect: "#ef4444",
    skipped: "#f59e0b",
  };

  // Extract time values
  const times = Add?.questions_line?.map(
    (item: any) => item.time_taken_seconds
  );

  // Map result type: "correct", "incorrect", or "skipped"
  const results: ResultType[] = Add?.questions_line?.map((item: any) => {
    if (item.skipped) return "skipped";
    return item.correct === "correct" ? "correct" : "incorrect";
  });

  // Strongly type the results array
  // const results: ResultType[] = [
  //   ...Array(16).fill("correct"),
  //   ...Array(5).fill("incorrect"),
  //   ...Array(16).fill("skipped"),
  // ];

  const option = {
    tooltip: {
      trigger: "axis",
      formatter: function (params: any) {
        const item = params[0];
        const index = item.dataIndex;
        const time = item.value;
        const status = results[index]; // from your mapped result array

        return `
      <strong>Question ${index + 1}</strong><br/>
      Status: ${status.charAt(0).toUpperCase() + status.slice(1)}<br/>
      Time: ${time}s
    `;
      },
      backgroundColor: "#fff",
      borderColor: "#ccc",
      borderWidth: 1,
      textStyle: {
        color: "#000",
        fontSize: 12,
      },
      extraCssText: "box-shadow: 0px 0px 10px rgba(0,0,0,0.1);",
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "10%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      data: Array.from({ length: times?.length }, (_, i) => i + 1),
      axisTick: { show: false },
    },
    yAxis: {
      type: "value",
      name: "Time Spent (sec)",
      max: 100,
    },
    series: [
      {
        type: "bar",
        data: times?.map((value: any, index: number) => ({
          value,
          itemStyle: {
            color: colors[results[index]],
          },
        })),
        barWidth: "60%",
      },
    ],
  };

  //  table and  chat

  // const getStatus = (percentage: number) => {
  //   if (percentage >= 50) return "Developing";
  //   return "Needs Work";
  // };
  const getStatus = (percentage: number) => {
    if (percentage >= 90) return "Outstanding";
    if (percentage >= 75) return "Proficient";
    if (percentage >= 50) return "Progressing";
    return "Emerging";
  };

  const getStatusColor = (status: string) => {
    return status === "Developing" ? "warning" : "error";
  };

  const avgTimeOption = {
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
      formatter: (params: any) => {
        const item = params[0];
        const index = item.dataIndex;
        const subtype = Add?.subtypes?.[index];

        const totalTime = subtype?.total_time_taken ?? 0;
        const totalCount = subtype?.total_count ?? 1;

        const avgSeconds = totalCount > 0 ? totalTime / totalCount : 0;
        const avgMinutes = avgSeconds / 60;

        return `
        <strong>${subtype?.subtype_name}</strong><br/>
        ${avgMinutes.toFixed(1)} minutes per question<br/>
        ${Math.round(avgSeconds)} seconds average
      `;
      },
    },
    grid: {
      left: "20%",
      right: "10%",
      bottom: "10%",
      top: "10%",
    },
    xAxis: {
      type: "value",
      name: "Minutes",
      nameLocation: "middle",
      nameGap: 30,
      axisLine: { show: false },
      axisTick: { show: false },
      splitLine: {
        lineStyle: {
          color: "#ddd",
          type: "dashed",
        },
      },
    },
    yAxis: {
      type: "category",
      axisTick: { show: false },
      axisLine: { show: false },
      axisLabel: {
        color: "#374151",
        fontWeight: 500,
        fontSize: 13,
      },
      data: Add?.subtypes?.map((item: any) => item.subtype_name) || [],
    },
    series: [
      {
        type: "bar",
        data:
          Add?.subtypes?.map((item: any) =>
            item.total_count > 0
              ? item.total_time_taken / item.total_count / 60
              : 0
          ) || [],
        barWidth: "60%",
        itemStyle: {
          color: (params: any) => {
            return params.dataIndex >= 3 ? "#F44336" : "#FFB300";
          },
          borderRadius: [0, 4, 4, 0],
        },
        label: {
          show: true,
          position: "right",
          fontWeight: 500,
          fontSize: 12,
          color: "#374151",
          formatter: ({ value }: any) => `${value.toFixed(1)} min`,
        },
      },
    ],
  };
  const writingresultdata = Add?.result_data?.map((item: any) => {
    return {
      ScoredData: item.score_board || [],
      Answer: item.answer || {},
    };
  });

  const scoredData: any = writingresultdata?.flatMap(
    (r: any) =>
      r.ScoredData?.find((item: any) => item?.title === "overall") || {
        score: 0,
        total_score: 0,
      }
  );

  const scoreData = scoredData?.[0];
  const stars = Math.round((scoreData?.score / scoreData?.total_score) * 5); // e.g., 49 -> 2 stars

  const ScoredData =
    writingresultdata?.[0]?.ScoredData?.map((item: any) => {
      const percentage = Math.round(
        (item.score / (item.total_score || 1)) * 100
      );

      return {
        ...item,
        percentage,
      };
    }) || [];

  console.log(ScoredData, "ScoredData");

  const performanceData: PerformanceCardProps = {
    title: "Performance Comparison",
    metrics:
      ScoredData.map((item: any) => ({
        label: item.title.charAt(0).toUpperCase() + item.title.slice(1),
        value: item.percentage,
      })) || [],
  };

  const timeTaken = scoreData?.total_time_spent || null;
  const studentAnswer = writingresultdata?.[0]?.Answer.student_answer || "";

  const stats = analyzeWritingWithTimeString(studentAnswer, timeTaken);
  // Map title to icon and colors

  const updatedList =
    writingresultdata?.flatMap((r: any) =>
      r.ScoredData?.map((item: any) => {
        const title = item?.title?.trim();
        const percent = Math.round(
          (item?.score / (item?.total_score || 1)) * 100
        );

        // Set icon/color directly
        let icon = "";
        let bgColor = "#f3f4f6";
        let color = "#6b7280";

        if (title === "creativity") {
          icon = start;
          bgColor = "#bbf7d0";
          color = "#22c55e";
        } else if (title === "structure") {
          icon = Yellowball;
          bgColor = "#fde68a";
          color = "#f97316";
        } else if (title === "grammar") {
          icon = greenball;
          bgColor = "#fecaca";
          color = "#ef4444";
        }
        if (title === "overall") {
          icon = Redball;
          bgColor = "#fecaca";
          color = "#ef4444";
        }

        return {
          ...item,
          percent,
          icon,
          bgColor,
          color,
        };
      })
    ) ?? [];

  // const updatedLists =
  //      writingresultdata?.flatMap((r:any) =>
  //     r.ScoredData?.map((item: any) => {
  //       const title = item?.title?.trim();
  //       const percent = Math.round(
  //         (item?.score / (item?.total_score || 1)) * 100
  //       );

  //     // Set icon/color directly
  //     let icon = "";
  //     let bgColor = "#f3f4f6";
  //     let color = "#6b7280";

  //     if (title === "creativity") {
  //       icon = difficultIcon;
  //       bgColor = "#bbf7d0";
  //       color = "#22c55e";
  //     } else if (title === "structure") {
  //       icon = easyIcon;
  //       bgColor = "#fde68a";
  //       color = "#f97316";
  //     } else if (title === "grammar") {
  //       icon = moderateIcon;
  //       bgColor = "#fecaca";
  //       color = "#ef4444";
  //     } else if (title === "overall") {
  //       icon = moderateIcon;
  //       bgColor = "#fecaca";
  //       color = "#ef4444";
  //     }

  //     return {
  //       ...item,
  //       percent,
  //       icon,
  //       bgColor,
  //       color,
  //     };
  //     })) ?? [];

  const writingStatsData = {
    title: "Writing Stats",
    wordsWritten: stats.words,
    characters: stats.charactersWithoutSpace,
    sentences: stats.sentences,
    paragraphs: stats.paragraphs,
    status:
      stats.wpm && stats.wpm >= 15
        ? "Excellent"
        : stats.wpm && stats.wpm >= 10
          ? "Good"
          : "Needs Practice",
    efficiency: stats.wpm
      ? `Time Efficiency (${stats.wpm} WPM)`
      : "Time Efficiency (N/A)",
  };

  // important

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);

    const part1 = date.toLocaleDateString("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric",
    });

    const part2 = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });

    return `${part1} at ${part2}`;
  };

  const questions = Add?.questions_line; // your JSON array

  const timeslist = questions?.map((q: any) =>
    q.time_taken_seconds === null ? 0 : q.time_taken_seconds
  );

  const resultslist = questions?.map((q: any) => {
    if (q.skipped) return "skipped";
    if (q.correct === true) return "correct";
    if (q.correct === false) return "incorrect";
    return "skipped"; // fallback
  });
  const colorslist = {
    correct: "#4caf50", // green
    incorrect: "#f44336", // red
    skipped: "#ffa726", // orange
  };

  const optionlist = {
    tooltip: {
      trigger: "axis",
      formatter: function (params: any) {
        const item = params[0];
        const index = item.dataIndex;
        const time = item.value;
        const status = results[index];

        return `
        <strong>Question ${index + 1}</strong><br/>
        Status: ${status.charAt(0).toUpperCase() + status.slice(1)}<br/>
        Time: ${time}s
      `;
      },
      backgroundColor: "#fff",
      borderColor: "#ccc",
      borderWidth: 1,
      textStyle: {
        color: "#000",
        fontSize: 12,
      },
      extraCssText: "box-shadow: 0px 0px 10px rgba(0,0,0,0.1);",
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "10%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      data: Array.from({ length: timeslist?.length }, (_, i) => i + 1),
      boundaryGap: true,
      axisTick: { show: true, inside: false, alignWithLabel: true },
      axisLine: { show: true },
      splitLine: {
        show: true,
        interval: -1,
        lineStyle: { type: "dashed", width: 1 },
      },
    },
    yAxis: {
      type: "value",
      name: "Time Spent (sec)",
      max: 100,
      interval: 25,
      axisTick: {
        show: true,
        inside: false,
        length: 6,
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: "#6e7079",
          width: 1,
        },
      },
      splitLine: {
        show: true,
        lineStyle: { type: "dashed", width: 1 },
      },
      nameLocation: "middle",
      nameRotate: 90,
      nameGap: 60,
      nameTextStyle: {
        fontSize: "16px",
        align: "left",
        verticalAlign: "top",
      },
    },
    series: [
      {
        type: "bar",
        data: timeslist?.map((value: any, index: any) => ({
          value,
          itemStyle: {
            color: colors[results[index]],
          },
        })),
        barWidth: "80%",
      },
    ],
  };

  const [chatbotOpen, setChatbotOpen] = React.useState<boolean>(false);

  const [showSubmitAlert, setShowSubmitAlert] = useState(
    showSubmitAlertFromState
  );
  console.log();
  const SnackTriggerHandler = ({
    showAlert,
    showSubmitAlert,
    setShowSubmitAlert,
  }: {
    showAlert: ShowAlertFunction;
    showSubmitAlert: boolean;
    setShowSubmitAlert: React.Dispatch<React.SetStateAction<boolean>>;
  }) => {
    useEffect(() => {
      if (showSubmitAlert) {
        showAlert(
          "success",
          <>
            <strong style={{ fontSize: "14px" }}>Test submitted</strong>
            <br />
            Your answers have been successfully submitted.
          </>,
          3000
        );
        setShowSubmitAlert(false);
      }
    }, [showSubmitAlert, showAlert, setShowSubmitAlert]);

    return null;
  };
  console.log(Add?.question_type_details, "averge sub type");

  console.log(Add?.question_type_details, "averge type res");
  const validSubtypeItems = Add?.question_type_details?.filter(
    (item: QuestionTypeDetail) =>
      item.subtypes !== null && item.subtypes.length > 0
  );

  // Permanent blocker - only allow specific routes
  const blocker = useBlocker(({ currentLocation, nextLocation }) => {
    // All routes that should be allowed from exam results
    const allowedRoutes = [
      "/minimockexam",
      "/mockexam",
      "/dashboard",
      "/feedback",
      "/reviewexam",
      "/minimockexam",
      "/mockexam",
      "/dashboard",
      "/feedback",
      "/reviewexam",
      "/login",
      "/home",
    ];

    const currentPath = currentLocation.pathname;
    const nextPath = nextLocation.pathname;

    // Don't block if staying on same page or going to allowed routes
    if (currentPath === nextPath || allowedRoutes.includes(nextPath)) {
      return false;
    }

    // Permanently block everything else
    return true;
  });

  useEffect(() => {
    if (blocker.state === "blocked") {
      blocker.reset();
    }
  }, [blocker]);

  console.log(validSubtypeItems, "valid items with non-empty subtypes");

  console.log(validSubtypeItems, "valid items without null subtypes");

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: "#FFFFFF",
          display: "flex",
          boxShadow: "0px 4px 40px 0px #0000000D",
        }}
      >
        <Toolbar
          sx={{
            minHeight: "0px",
            display: "flex",
            justifyContent: "space-between",
            paddingLeft: "0px",
            paddingRight: "0px",
            margin: "0% 5%",
            height: "50px",
          }}
        >
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ display: "flex", gap: "20px", alignItems: "center" }}
          >
            <SvgIcon
              sx={{
                width: "123px",
                height: "50px",
                marginTop: "10px",
                cursor: "pointer",
              }}
              color="primary"
              component={Logo}
              inheritViewBox
              onClick={() => {
                navigate("/dashboard");
              }}
            />
          </Typography>
          <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
            <div
              style={{
                display: "flex",
                color: "#009dff",
                fontSize: "16px",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(
                  Add?.exam_name === "Mini Mock Test"
                    ? "/minimockexam"
                    : "/mockexam"
                );
              }}
            >
              <ArrowBackIosIcon sx={{ color: "#009dff" }} />
              <div style={{ color: "#009dff", fontSize: "15px" }}>
                {" "}
                Back To exams
              </div>
            </div>
          </div>
        </Toolbar>
      </AppBar>

      {isLoading ? (
        <Box
          sx={{
            marginTop: "64px",
            width: "100%",
            height: "calc(100vh - 64px)",
            backgroundColor: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Loading isLoading={true} />
        </Box>
      ) : (
        <>
          <Box
            sx={{
              borderRadius: 3,
              minHeight: "100vh",
              p: "4% 7%",
              backgroundColor: "#f5faff",
            }}
          >
            <Box
              sx={{
                backgroundColor: "#f5faff", // very light blue
                p: 4,
                borderRadius: 2,
                textAlign: "center",
              }}
            >
              {/* Title */}
              <Typography
                variant="h3"
                sx={{
                  fontWeight: "bold",
                  color: "#1a237e", // dark blue
                  mb: 2,
                }}
              >
                {Add?.exam_name} Exam Results
              </Typography>

              {/* Vertical Divider with Icon */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 2,
                  mt: 2,
                }}
              >
                {/* Wrap line and summary in a flex row */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Box
                    sx={{
                      borderLeft: "4px solid #009dff",
                      height: 60,
                      display: "flex",
                      alignItems: "center",
                      px: 1,
                    }}
                  />
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <InfoIcon sx={{ color: "#009dff", fontSize: 20 }} />
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontWeight: 500,
                          color: "#009dff",
                          fontSize: "16px",
                        }}
                      >
                        Performance Summary
                      </Typography>
                    </Box>
                    <Typography
                      variant="body2"
                      sx={{ color: "#4b5563", fontSize: "14px", mt: 1 }}
                    >
                      {Add?.performance_summary}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>

            {/* Main Content Grid */}
            <Grid container spacing={isMobile ? 2 : 4}>
              {/* Score Card */}
              <Grid item xs={12} sm={12} md={12} lg={6}>
                <Paper
                  elevation={0}
                  sx={{
                    backgroundColor: "white",
                    borderRadius: 3,
                    p: 3,
                    height: "100%",
                  }}
                >
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 500,
                      mb: 2,
                      color: "black",
                      textAlign: "center",
                      fontSize: "20px",
                    }}
                  >
                    Your Score
                  </Typography>

                  <Box sx={{ textAlign: "center", mb: 2 }}>
                    <Typography
                      variant={isMobile ? "h2" : "h1"}
                      sx={{
                        fontWeight: 700,
                        color: "#009dff",
                        lineHeight: 1,
                        fontSize: "5rem",
                      }}
                    >
                      {Add?.total_correct}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 400,
                        color: "#37474f",
                        fontSize: "1.5rem",
                      }}
                    >
                      Out of {Add?.total_questions}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1.5,
                      p: 2,
                      backgroundColor: "#fff",
                    }}
                  >
                    {/* Accuracy and Time Taken Row */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      <Box>
                        <Typography
                          variant="h5"
                          sx={{
                            fontWeight: 500,
                            color: "#000",
                            mb: 0.5,
                            fontSize: "20px",
                          }}
                        >
                          Accuracy
                        </Typography>
                        <Typography
                          variant="h5"
                          sx={{
                            fontWeight: 500,
                            color: "#000",
                            mb: 0.5,
                            fontSize: "20px",
                          }}
                        >
                          Time Taken
                        </Typography>
                        <Typography
                          variant="h5"
                          sx={{
                            fontWeight: 500,
                            color: "#4B5563",
                            mb: 0.5,
                            fontSize: "18px",
                          }}
                        >
                          Completed
                        </Typography>
                      </Box>

                      <Box>
                        <Typography
                          variant="h5"
                          sx={{
                            fontWeight: 500,
                            color: "#000",
                            mb: 0.5,
                            textAlign: "right",
                            fontSize: "20px",
                          }}
                        >
                          {percentage}%
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            justifyContent: "flex-end",
                            mb: 0.5,
                          }}
                        >
                          <AccessTimeIcon
                            fontSize="medium"
                            sx={{ fontSize: "20px" }}
                          />
                          <Typography
                            variant="h5"
                            sx={{
                              fontWeight: 600,
                              color: "#000",
                              fontSize: "20px",
                            }}
                          >
                            {Add?.total_timing}
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            textAlign: "right",
                            mb: 0.5,
                          }}
                        >
                          <CalendarMonthIcon
                            fontSize="small"
                            sx={{ color: "#4B5563", fontSize: "20px" }}
                          />

                          <Typography
                            variant="h5"
                            sx={{
                              fontWeight: 600,
                              color: "#4B5563",
                              textAlign: "right",
                              fontSize: "18px",
                            }}
                          >
                            {formatDate(Add?.exit_time)}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Paper>
              </Grid>

              {/* Performance Overview */}
              <Grid item xs={12} sm={12} md={12} lg={6}>
                <Paper
                  elevation={0}
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: 3,
                    p: 3,
                    height: "100%",
                  }}
                >
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 500,
                      mb: 2,
                      color: "black",
                      textAlign: "center",
                    }}
                  >
                    Performance Overview
                  </Typography>

                  <Box sx={{ mb: 3, textAlign: "center" }}>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#4b5563",
                        display: "inline",
                        fontSize: "14px",
                      }}
                    >
                      Performance Level:{" "}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        display: "inline",
                        fontSize: "14px",
                        fontWeight: 600,
                        color:
                          getStatus(percentage) === "Outstanding"
                            ? "#22c55e"
                            : getStatus(percentage) === "Proficient"
                              ? "#f59e42"
                              : getStatus(percentage) === "Progressing"
                                ? "#2563eb"
                                : "#9f211b",
                      }}
                    >
                      {getStatus(percentage)} ({percentage}%)
                    </Typography>
                  </Box>

                  <Grid container spacing={2}>
                    {/* Correct */}
                    <Grid item xs={4}>
                      <Paper
                        sx={{
                          backgroundColor: "#f0fdf4",
                          p: 2,
                          textAlign: "center",
                          height: "100%",
                          display: "flex",
                          boxShadow: "none",
                          flexDirection: "column",
                          justifyContent: "center",
                        }}
                      >
                        <Typography
                          variant={isMobile ? "h5" : "h4"}
                          sx={{
                            color: "#22c55e",
                            fontWeight: 700,
                            lineHeight: 1,
                          }}
                        >
                          {Add?.total_correct}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            mt: 1,
                            fontWeight: 400,
                            fontSize: "12px",
                          }}
                        >
                          Correct
                        </Typography>
                      </Paper>
                    </Grid>

                    {/* Incorrect */}
                    <Grid item xs={4}>
                      <Paper
                        sx={{
                          backgroundColor: "#fef2f2",
                          p: 2,
                          textAlign: "center",
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          boxShadow: "none",
                        }}
                      >
                        <Typography
                          variant={isMobile ? "h5" : "h4"}
                          sx={{
                            color: "#d32f2f",
                            fontWeight: 700,
                            lineHeight: 1,
                          }}
                        >
                          {Add?.total_wrong}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            mt: 1,
                            fontWeight: 400,
                            fontSize: "12px",
                          }}
                        >
                          Incorrect
                        </Typography>
                      </Paper>
                    </Grid>

                    {/* Skipped */}
                    <Grid item xs={4}>
                      <Paper
                        sx={{
                          backgroundColor: "#fff7ed",
                          p: 2,
                          textAlign: "center",
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          boxShadow: "none",
                        }}
                      >
                        <Typography
                          variant={isMobile ? "h5" : "h4"}
                          sx={{
                            color: "#f57c00",
                            fontWeight: 700,
                            lineHeight: 1,
                          }}
                        >
                          {Add?.total_skipped}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            mt: 1,
                            fontWeight: 400,
                            fontSize: "12px",
                          }}
                        >
                          Skipped
                        </Typography>
                      </Paper>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>

            <Box sx={{ mt: 4 }}>
              {/* Chat Suggestion Box */}

              <Box sx={{ mt: 2, mb: 2 }}>
                {/* Chat Suggestion Box */}
                <Paper
                  elevation={0}
                  sx={{
                    borderRadius: "15px",
                    p: "24px",
                    display: "flex",
                    justifyContent: "space-between",
                    border: "1px solid",
                    borderColor: "#cce4f7",
                    background: "linear-gradient(to right, #e3f2fd, #f8fbff)",
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
                    alignItems: "center",
                    flexDirection: isMobile ? "column" : "row",
                    gap: 2,
                  }}
                >
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <div
                      className="blinking-avatar-container"
                      style={{
                        minWidth: "56px",
                        height: "56px",
                      }}
                    >
                      <Avatar
                        src={AvatarImage}
                        alt="Profile"
                        className="blinking-avatar"
                        sx={{
                          width: "40px !important",
                          height: "40px !important",
                        }}
                      />
                    </div>

                    <Box>
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: "18px",
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        💬 Need personalized study tips? Chat with Elliot!
                      </Typography>
                      <Typography sx={{ fontSize: "14px", color: "#424242" }}>
                        I can analyze your test results and provide targeted
                        recommendations to improve your weak areas.
                      </Typography>
                    </Box>
                  </Stack>

                  <Button
                    variant="contained"
                    startIcon={<ChatBubbleOutlineIcon />}
                    sx={{
                      borderRadius: "10px",
                      fontWeight: 500,
                      textTransform: "none",
                      px: 3,
                      py: 1,
                      color: "white",
                      fontSize: "14px",
                      backgroundColor: "#009dff",
                      "&:hover": {
                        backgroundColor: "#1976d2",
                      },
                    }}
                    onClick={() => {
                      dispatch(clearChatbotStatus());
                      dispatch(clearChatbotPublicStatus());
                      dispatch(clearReadChatbotPublicStatus());
                      dispatch(clearWritingChatbotPublicStatus());
                      dispatch(clearExamReadChatbotPublicStatus());
                      dispatch(clearExamWritingChatbotPublicStatus());
                      setChatbotOpen(true);
                    }}
                  >
                    Chat Now
                  </Button>
                </Paper>
                <ChatbotExamEvaluation
                  open={chatbotOpen}
                  setOpen={setChatbotOpen}
                  student_exam_id={student_exam_id}
                />
              </Box>
              <ChatbotExamEvaluation
                open={chatbotOpen}
                setOpen={setChatbotOpen}
                student_exam_id={student_exam_id}
              />

              {/* Buttons below */}
              <Box
                sx={{
                  mt: 3,
                  mb: 3,
                  p: "20px",
                  bgcolor: "#fff",
                  borderRadius: "20px",
                  display: "flex",
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.04)",
                  background: "white",
                  flexDirection: isMobile ? "column" : "row",
                  gap: 2,
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Button
                  variant="outlined"
                  startIcon={<ChatIcon />}
                  sx={{
                    flex: 1,
                    fontWeight: 500,
                    fontSize: "18px",
                    borderRadius: "12px",
                    // py: 1.2,
                    padding: "6px",
                    textTransform: "none",
                    borderColor: "#2196f3",
                    color: "#2196f3",
                    "&:hover": {
                      borderColor: "#1976d2",
                      backgroundColor: "#e3f2fd",
                    },
                  }}
                  onClick={() => {
                    navigate("/feedback", { state: id || review_id }); // Replace with your target route
                  }}
                >
                  Proceed to Feedback
                </Button>

                <Button
                  variant="contained"
                  startIcon={<VisibilityIcon />}
                  sx={{
                    flex: 1,
                    fontWeight: 500,
                    fontSize: "18px",
                    backgroundColor: "#009dff",
                    borderRadius: "12px",
                    // py: 1.2,
                    padding: "6px",
                    color: "white",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#0288d1",
                    },
                  }}
                  onClick={() => {
                    dispatch(clearListReViewExamID());
                    navigate("/reviewexam", { state: id || review_id });
                  }}
                >
                  View Solutions
                </Button>
              </Box>
            </Box>

            {/* chat list  */}

            <Paper
              sx={{
                borderRadius: "20px",
                p: 3,
                backgroundColor: "#ffffff",
                boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.04)",
              }}
            >
              <Typography variant="h6" sx={{ fontSize: "20px" }}>
                Question Report
              </Typography>

              <Grid
                container
                spacing={2}
                alignItems="center"
                justifyContent="space-between"
                sx={{
                  my: 2,
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-around",
                }}
              >
                <Grid
                  item
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="h4"
                    sx={{ fontWeight: 700, color: "#111827", fontSize: "24px" }}
                  >
                    {Add?.total_questions}
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: "14px" }}>
                    Questions
                  </Typography>
                </Grid>

                <Grid
                  item
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="h4"
                    sx={{ color: "#22c55e", fontWeight: 700, fontSize: "24px" }}
                  >
                    {Add?.total_correct}
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: "14px" }}>
                    Correct
                  </Typography>
                </Grid>

                <Grid
                  item
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="h4"
                    sx={{ color: "#ef4444", fontWeight: 700, fontSize: "24px" }}
                  >
                    {Add?.total_wrong}
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: "14px" }}>
                    Incorrect
                  </Typography>
                </Grid>

                <Grid
                  item
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="h4"
                    sx={{ color: "#f59e0b", fontWeight: 700, fontSize: "24px" }}
                  >
                    {Add?.total_skipped}
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: "14px" }}>
                    Skipped
                  </Typography>
                </Grid>
              </Grid>

              <Box
                sx={{
                  height: "8px",
                  width: "100%",
                  borderRadius: "8px",
                  backgroundColor: "#e0e0e0",
                  overflow: "hidden",
                  mb: 2,
                  display: "flex",
                }}
              >
                {(() => {
                  const total =
                    (Add?.total_correct || 0) +
                    (Add?.total_wrong || 0) +
                    (Add?.total_skipped || 0);

                  const sections = [
                    {
                      value: Add?.total_correct || 0,
                      color: colors.correct,
                    },
                    {
                      value: Add?.total_wrong || 0,
                      color: colors.incorrect,
                    },
                    {
                      value: Add?.total_skipped || 0,
                      color: colors.skipped,
                    },
                  ];

                  return sections.map((section, index) => (
                    <Box
                      key={index}
                      sx={{
                        width: `${(section.value / total) * 100}%`,
                        backgroundColor: section.color,
                        height: "100%",
                      }}
                    />
                  ));
                })()}
              </Box>

              <Grid
                item
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <AccessTimeIcon
                  sx={{ fontSize: "20px", mr: 1, color: "#616161" }}
                />
                <Typography variant="body2" sx={{ fontSize: "14px" }}>
                  {formatTime(Add?.total_timing)} Time Taken
                </Typography>
              </Grid>

              {/* Chart */}
              <ReactECharts
                option={optionlist}
                style={{ height: 300, width: "100%" }}
              />

              {/* Legend */}
              <Grid
                container
                justifyContent="center"
                spacing={2}
                sx={{ mt: 2 }}
              >
                {["Correct", "Incorrect", "Skipped"].map((label) => (
                  <Grid item key={label}>
                    <Box display="flex" alignItems="center">
                      <Box
                        sx={{
                          width: 16,
                          height: 16,
                          borderRadius: "4px",
                          backgroundColor:
                            colors[label.toLowerCase() as keyof typeof colors],
                          mr: 1,
                        }}
                      />
                      <Typography variant="body2" sx={{ fontSize: "14px" }}>
                        {label}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Paper>

            {/* table and chat  */}
            <Box
              sx={{
                p: isMobile ? 2 : "32px 0px  32px 0px",
              }}
            >
              {/* Performance Table */}
              {validSubtypeItems?.length > 0 && (
                <Paper
                  elevation={3}
                  sx={{
                    p: 3,
                    borderRadius: "20px",
                    mb: 4,
                    boxShadow: "0px 37px 37px rgba(0, 157, 255, 0.1)",
                  }}
                >
                  <Typography variant="h6" sx={{ fontSize: "20px" }}>
                    Performance by Sub-Type
                  </Typography>
                  <Box sx={{ overflowX: "auto" }}>
                    <Box
                      component="table"
                      width="100%"
                      sx={{
                        borderSpacing: "0 16px",
                        minWidth: "700px",
                      }}
                    >
                      <thead>
                        <tr>
                          {[
                            "Sub-Type",
                            "Performance",
                            "Correct",
                            "Incorrect",
                            "Skipped",
                            "Percentage",
                            "Status",
                          ].map((head) => (
                            <th
                              key={head}
                              style={{
                                textAlign: "left",
                                paddingBottom: 8,
                                fontWeight: 500,
                                fontSize: "14px",
                                color: "#64748b",
                                backgroundColor: "white",
                                paddingRight: 16,
                                whiteSpace: "nowrap", // Prevent text wrap
                              }}
                            >
                              {head}
                            </th>
                          ))}
                        </tr>
                      </thead>

                      <tbody>
                        {validSubtypeItems?.map((qType: any, index: number) => (
                          <React.Fragment key={index}>
                            {/* Section Heading Row */}
                            <tr>
                              <td
                                colSpan={7}
                                style={{
                                  fontWeight: 600,
                                  fontSize: "18px",
                                  padding: "12px 0",
                                  color: "#1e293b",
                                }}
                              >
                                {qType?.question_type_name}
                              </td>
                            </tr>

                            {/* Subtype Rows */}
                            {qType?.subtypes?.map((item: any, idx: number) => {
                              const percentage =
                                item.total_count > 0
                                  ? (
                                    (item.total_correct / item.total_count) *
                                    100
                                  ).toFixed(1)
                                  : "0.0";

                              const skipped =
                                item.total_count -
                                item.total_correct -
                                item.total_wrong;
                              const status = getStatus(+percentage);

                              return (
                                <tr
                                  key={idx}
                                  style={{ verticalAlign: "middle" }}
                                >
                                  <td
                                    style={{
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      paddingRight: 16,
                                    }}
                                  >
                                    {item.subtype_name}
                                  </td>
                                  <td
                                    style={{ width: "180px", paddingRight: 16 }}
                                  >
                                    <LinearProgress
                                      variant="determinate"
                                      value={+percentage}
                                      sx={{
                                        height: 10,
                                        borderRadius: 5,
                                        backgroundColor: "#e5e7eb", // makes the track transparent
                                        "& .MuiLinearProgress-bar": {
                                          backgroundColor: "#009dff", // or any blue you want
                                          borderRadius: 5,
                                        },
                                      }}
                                    />
                                  </td>
                                  <td
                                    style={{
                                      paddingRight: 16,
                                      fontSize: "14px",
                                    }}
                                  >
                                    {`${item.total_correct}/${item.total_count}`}
                                  </td>
                                  <td
                                    style={{
                                      paddingRight: 16,
                                      fontSize: "14px",
                                    }}
                                  >
                                    {`${item.total_wrong}/${item.total_count}`}
                                  </td>
                                  <td
                                    style={{
                                      paddingRight: 16,
                                      fontSize: "14px",
                                    }}
                                  >
                                    {`${skipped}/${item.total_count}`}
                                  </td>
                                  <td
                                    style={{
                                      paddingRight: 16,
                                      fontSize: "14px",
                                    }}
                                  >
                                    {percentage}%
                                  </td>
                                  <td>
                                    <Chip
                                      label={status}
                                      // color={getStatusColor(status)}
                                      sx={{
                                        background:
                                          status === "Outstanding"
                                            ? "#bbf7d0"
                                            : status === "Proficient"
                                              ? "#fde68a"
                                              : status === "Progressing"
                                                ? "#dbeafe"
                                                : "#fee2e2",
                                        color:
                                          status === "Outstanding"
                                            ? "#22c55e"
                                            : status === "Proficient"
                                              ? "#f59e42"
                                              : status === "Progressing"
                                                ? "#2563eb"
                                                : "#9f211b",
                                        fontWeight: "500",
                                      }}
                                      size="small"
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                          </React.Fragment>
                        ))}
                      </tbody>
                    </Box>
                  </Box>
                </Paper>
              )}
              <Box sx={{ margin: "5% 0%" }}>
                {/* ✅ Overall Score Card (Render only if scoreData exists) */}
                {scoreData && (
                  <Card
                    sx={{
                      p: 4,
                      mb: 4,
                      backgroundColor: "#00aaff",
                      color: "#fff",
                      borderRadius: 2,
                      boxShadow: 3,
                    }}
                  >
                    <Stack
                      direction={{ xs: "column", sm: "row" }}
                      justifyContent="space-between"
                      alignItems="center"
                      spacing={2}
                    >
                      <div>
                        <Typography
                          variant="h5"
                          fontWeight={700}
                          sx={{ fontSize: "30px" }}
                          gutterBottom
                        >
                          Overall Score
                        </Typography>
                        <Typography
                          variant="body1"
                          mb={2}
                          sx={{ fontSize: "18px", color: "#f1f1f1" }}
                        >
                          You scored {scoreData?.score} out of{" "}
                          {scoreData?.total_score} points
                        </Typography>

                        {scoreData?.total_time_spent && (
                          <Chip
                            label={
                              <Box display="flex" alignItems="center" gap={1}>
                                <AccessTimeIcon
                                  fontSize="large"
                                  sx={{ fontSize: "24px" }}
                                />
                                <Typography
                                  variant="body2"
                                  sx={{ fontSize: "16px", fontWeight: 500 }}
                                >
                                  Time taken:
                                  <span
                                    style={{
                                      fontSize: "18px",
                                      fontWeight: 600,
                                      marginLeft: "3px",
                                    }}
                                  >
                                    {formatTime(scoreData.total_time_spent)}
                                  </span>
                                </Typography>
                              </Box>
                            }
                            sx={{
                              backgroundColor: "rgba(255, 255, 255, 0.2)",
                              color: "white",
                              fontWeight: 500,
                              borderRadius: "8px",
                              height: "42px",
                            }}
                          />
                        )}
                      </div>

                      {/* Circular Score Chart */}
                      <div>
                        <Box
                          alignItems="center"
                          gap={2}
                          sx={{ display: "flex", flexDirection: "column" }}
                        >
                          <Box position="relative" display="inline-flex">
                            <CircularProgress
                              variant="determinate"
                              value={100}
                              size={100}
                              thickness={4}
                              sx={{
                                color: "#5fc8ff",
                                position: "absolute",
                                zIndex: 0,
                              }}
                            />
                            <CircularProgress
                              variant="determinate"
                              value={
                                ((scoreData?.score || 0) /
                                  (scoreData?.total_score || 1)) *
                                100
                              }
                              size={100}
                              thickness={4}
                              sx={{
                                color: "#ffffff",
                                position: "relative",
                                zIndex: 1,
                              }}
                            />
                            <Box
                              position="absolute"
                              top={0}
                              left={0}
                              right={0}
                              bottom={0}
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                            >
                              <Typography
                                variant="h3"
                                fontWeight={700}
                                fontSize={"30px"}
                              >
                                {Math.round(
                                  ((scoreData?.score || 0) /
                                    (scoreData?.total_score || 1)) *
                                  100
                                )}
                                %
                              </Typography>
                            </Box>
                          </Box>

                          {/* Stars */}
                          <Box display="flex">
                            {[1, 2, 3, 4, 5].map((i) => (
                              <StarIcon
                                key={i}
                                sx={{
                                  color: i <= stars ? "#ffc107" : "#e0e0e0",
                                  fontSize: 29,
                                }}
                              />
                            ))}
                          </Box>
                        </Box>
                      </div>
                    </Stack>
                  </Card>
                )}

                <Grid container spacing={4}>
                  {/* Detailed Breakdown */}
                  <Grid
                    item
                    xs={12}
                    md={6}
                    display={"flex"}
                    flexDirection={"column"}
                    gap={"20px"}
                  >
                    <Typography
                      variant="h5"
                      sx={{ fontSize: "20px" }}
                      fontWeight={700}
                      gutterBottom
                    >
                      Detailed Breakdown
                    </Typography>
                    <Grid container spacing={2}>
                      {updatedList?.length > 1 &&
                        updatedList.map((section: any, index: number) => (
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={12}
                            key={index}
                          >
                            <Box
                              key={index}
                              sx={{
                                backgroundColor: "#fff",
                                borderRadius: 3,
                                boxShadow: "0px 2px 8px rgba(0,0,0,0.06)",
                                p: 2,
                              }}
                            >
                              <Box display="flex" alignItems="center" mb={1}>
                                <Box
                                  sx={{
                                    width: 40,
                                    height: 40,
                                    borderRadius: "50%",
                                    backgroundColor:
                                      section.percent <= 50
                                        ? "#fecaca"
                                        : section.percent > 50 &&
                                          section.percent < 70
                                          ? "#fde68a"
                                          : section.percent > 70
                                            ? "#bbf7d0"
                                            : section.color,

                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    mr: 2,
                                  }}
                                >
                                  {section.title === "structure" ? (
                                    <SvgIcon
                                      component={DetailsStructure}
                                      sx={{ fill: "none", color: "red" }}
                                    />
                                  ) : section.title === "creativity" ? (
                                    <SvgIcon
                                      component={DetailsLightbulb}
                                      sx={{ fill: "none" }}
                                    />
                                  ) : section.title === "overall" ? (
                                    <SvgIcon
                                      component={DetailsOverall}
                                      sx={{ fill: "none" }}
                                    />
                                  ) : (
                                    <SvgIcon
                                      component={DetailsOverall}
                                      sx={{ fill: "none" }}
                                    />
                                  )}
                                </Box>

                                <Box flexGrow={1}>
                                  <Typography
                                    fontWeight={600}
                                    fontSize={18}
                                    textTransform="capitalize"
                                    marginBottom={"4px"}
                                  >
                                    {section.title}
                                  </Typography>
                                  <Typography fontSize={14} color="#6b7280">
                                    {section.percent}%
                                  </Typography>
                                </Box>

                                <Box textAlign="right">
                                  <Typography fontWeight={600} fontSize={24}>
                                    {section.score}
                                  </Typography>
                                  <Typography fontSize={14} color="#6b7280">
                                    out of {section.total_score}
                                  </Typography>
                                </Box>
                              </Box>

                              <LinearProgress
                                variant="determinate"
                                value={section.percent}
                                sx={{
                                  height: 10,
                                  borderRadius: 5,
                                  marginTop: "16px",
                                  backgroundColor: "#e5e7eb",
                                  "& .MuiLinearProgress-bar": {
                                    backgroundColor:
                                      section.percent <= 50
                                        ? "#ef4444"
                                        : section.percent > 50 &&
                                          section.percent < 70
                                          ? "#f97316"
                                          : section.percent > 70
                                            ? "#22c55e"
                                            : section.color,
                                  },
                                }}
                              />
                            </Box>
                          </Grid>
                        ))}
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} padding={"0px"}>
                      <PerformanceComparisonCard data={performanceData} />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} padding={"0px"}>
                      <WritingStatsCard data={writingStatsData} />
                    </Grid>
                  </Grid>

                  {/* Detailed Feedback */}
                  <Grid
                    item
                    xs={12}
                    md={6}
                    display={"flex"}
                    flexDirection={"column"}
                    gap={"20px"}
                  >
                    <Typography
                      variant="h5"
                      sx={{ fontSize: "20px" }}
                      fontWeight={700}
                      gutterBottom
                    >
                      Detailed Feedback
                    </Typography>
                    <Grid container spacing={2}>
                      {updatedList?.length > 1 &&
                        updatedList.map((section: any, index: number) => (
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={12}
                            key={index}
                          >
                            <Box
                              key={index}
                              sx={{
                                backgroundColor: "#fff",
                                borderRadius: 2,
                                boxShadow: "0px 2px 6px rgba(0,0,0,0.08)",
                                p: 2,
                                // mb: 2,
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  width: "100%",
                                  gap: "10px",
                                  marginBottom: "10px",
                                  alignItems: "center",
                                }}
                              >
                                <Box
                                  sx={{
                                    borderRadius: "50%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <span
                                    style={{
                                      marginBottom: "2px",
                                      background:
                                        section.percent <= 50
                                          ? "#ef4444"
                                          : section.percent > 50 &&
                                            section.percent < 70
                                            ? "#f97316"
                                            : section.percent > 70
                                              ? "#22c55e"
                                              : section.color,
                                      padding: "8px",
                                      borderRadius: "10px",
                                    }}
                                  ></span>
                                  {/* <img
                          src={section.icon}
                          alt={section.title}
                          // style={{ width: 24, height: 24 }}
                        /> */}
                                </Box>
                                <Typography
                                  variant="subtitle1"
                                  fontWeight={600}
                                  gutterBottom
                                  sx={{
                                    textTransform: "capitalize",
                                    fontSize: "18px",
                                  }}
                                >
                                  {section?.title}
                                </Typography>
                              </div>
                              {/* <Typography
                          variant="body2"
                          color="#374151"
                          sx={{ fontSize: "16px" }}
                        >
                          {section?.feedback}
                        </Typography> */}
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1,
                                  marginBottom: "6px",
                                  padding: "0px 12px",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    color: "#475569",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <MessageSquare
                                    style={{
                                      width: "16px",
                                      height: "16px",
                                      marginRight: "5px",
                                    }}
                                  />
                                  <span style={{ fontSize: "14px" }}>
                                    Feedback
                                  </span>
                                </Typography>
                              </Box>

                              {/* Feedback Box */}
                              <Box
                                sx={{
                                  backgroundColor: "#f8fafc",
                                  borderRadius: "10px",
                                  padding: "14px",
                                  marginBottom: "15px",
                                  border: "1px solid #e2e8f0",
                                }}
                              >
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontSize: "14px",
                                    color: "#334155",
                                    lineHeight: 1.5,
                                  }}
                                >
                                  {section?.feedback}
                                </Typography>
                              </Box>

                              {/* Suggestion Title
  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
    <Typography sx={{ textTransform: "capitalize", fontWeight: "bold", fontSize: "14px", color: "#b45309" }}>
      💡 Suggestions
    </Typography>
  </Box> */}

                              {/* Suggestion Box */}
                              <Box
                                sx={{
                                  backgroundColor: "#fffbeb",
                                  borderRadius: " 0px 10px 10px 0px",
                                  padding: "14px",
                                  border: "0px solid #fbbf24",
                                  borderLeftWidth: "4px",
                                  marginTop: "10px",
                                }}
                              >
                                {" "}
                                <Typography
                                  sx={{
                                    textTransform: "capitalize",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    color: "#b45309",
                                    display: "flex",
                                    alignItems: "center",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <Lightbulb
                                    style={{
                                      width: "18px",
                                      height: "18px",
                                      marginRight: "5px",
                                    }}
                                  />
                                  <span>SUGGESTIONS</span>
                                </Typography>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontSize: "14px",
                                    color: "#92400e",
                                    lineHeight: 1.6,
                                  }}
                                >
                                  {section?.suggestion}
                                </Typography>
                              </Box>
                            </Box>
                          </Grid>
                        ))}
                    </Grid>
                  </Grid>
                </Grid>
              </Box>

              {/* Bottom Section */}
              <Grid container spacing={4}>
                {/* Donut Chart - Time Analysis */}
                <Grid item xs={12} md={6}>
                  <Paper
                    elevation={3}
                    sx={{
                      p: 3,
                      borderRadius: "10px",
                      height: "100%",
                      boxShadow: "0px 37px 37px rgba(0, 157, 255, 0.1)",
                    }}
                  >
                    <Typography variant="h6" sx={{ fontSize: "20px" }}>
                      Time Analysis
                    </Typography>
                    <ReactECharts
                      option={{
                        tooltip: {
                          trigger: "item",
                        },
                        graphic: {
                          elements: [
                            {
                              type: "text",
                              left: "center",
                              top: "center",
                              style: {
                                text: formattedTime, // e.g., "00h 20m 05s"
                                textAlign: "center",
                                fill: "#333",
                                fontSize: 18,
                                fontWeight: 700,
                              },
                            },
                            {
                              type: "text",
                              left: "center",
                              top: "60%", // Adjust this as needed
                              style: {
                                text: "Total Time",
                                textAlign: "center",
                                fill: "#333",
                                fontSize: 13,
                                fontWeight: 600,
                              },
                            },
                          ],
                        },
                        series: [
                          {
                            type: "pie",
                            radius: ["50%", "70%"],
                            avoidLabelOverlap: false,
                            label: { show: false },
                            emphasis: {
                              label: {
                                show: true,
                                fontSize: 16,
                                fontWeight: "bold",
                              },
                            },
                            labelLine: { show: false },
                            data: [
                              {
                                value: Add?.total_correct,
                                name: "Correct",
                                itemStyle: { color: "#4CAF50" },
                              },
                              {
                                value: Add?.total_wrong,
                                name: "Incorrect",
                                itemStyle: { color: "#F44336" },
                              },
                              {
                                value: Add?.total_skipped,
                                name: "Skipped",
                                itemStyle: { color: "#FF9800" },
                              },
                            ],
                          },
                        ],
                      }}
                      style={{ height: 250 }}
                    />
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mt: 2,
                        flexWrap: "wrap",
                      }}
                    >
                      <Box
                        sx={{ display: "flex", alignItems: "center", mx: 1 }}
                      >
                        <Box
                          sx={{
                            width: 10,
                            height: 10,
                            borderRadius: "50%",
                            backgroundColor: "#4CAF50",
                            mr: 1,
                          }}
                        />
                        <Typography
                          sx={{
                            fontWeight: 600,
                            color: "#4CAF50",
                          }}
                        >
                          <span style={{ fontSize: "14px" }}>{`Correct: ${Add?.total_correct || 0
                            }%`}</span>
                        </Typography>
                      </Box>
                      <Box
                        sx={{ display: "flex", alignItems: "center", mx: 1 }}
                      >
                        <Box
                          sx={{
                            width: 10,
                            height: 10,
                            borderRadius: "50%",
                            backgroundColor: "#F44336",
                            mr: 1,
                          }}
                        />
                        <Typography
                          sx={{
                            fontWeight: 600,
                            color: "#F44336",
                          }}
                        >
                          <span style={{ fontSize: "14px" }}>
                            {`Incorrect: ${Add?.total_wrong || 0}%`}
                          </span>
                        </Typography>
                      </Box>
                      <Box
                        sx={{ display: "flex", alignItems: "center", mx: 1 }}
                      >
                        <Box
                          sx={{
                            width: 10,
                            height: 10,
                            borderRadius: "50%",
                            backgroundColor: "#FF9800",
                            mr: 1,
                          }}
                        />
                        <Typography
                          sx={{
                            fontWeight: 600,
                            color: "#FF9800",
                          }}
                        >
                          <span style={{ fontSize: "14px" }}>
                            {`Skipped: ${Add?.total_skipped || 0}%`}
                          </span>
                        </Typography>
                      </Box>
                    </Box>
                  </Paper>
                </Grid>

                {/* Bar Chart - Average Time per Sub-Type */}

                <Grid item xs={12} md={6}>
                  {validSubtypeItems?.length > 0 && (
                    <Paper
                      elevation={3}
                      sx={{
                        p: 3,
                        borderRadius: "10px",
                        height: "100%",
                        boxShadow: "0px 37px 37px rgba(0, 157, 255, 0.1)",
                      }}
                    >
                      <Typography variant="h6" sx={{ fontSize: "20px" }}>
                        Average Time per Sub-Type
                      </Typography>

                      <SubTypeTimeCharts
                        question_type_details={Add.question_type_details}
                      />

                      <ReactECharts
                        option={avgTimeOption}
                        style={{ height: 280, width: "100%" }}
                      />
                    </Paper>
                  )}
                </Grid>
              </Grid>
            </Box>
          </Box>

          <button
            className="floating-chatbot-button "
            onClick={() => {
              dispatch(clearChatbotPublicStatus());
              dispatch(clearReadChatbotPublicStatus());
              dispatch(clearWritingChatbotPublicStatus());
              dispatch(clearExamReadChatbotPublicStatus());
              dispatch(clearExamWritingChatbotPublicStatus());
              setChatbotOpen(true);
            }}
          >
            <img
              src={AvatarImage}
              alt="Chat with Elliot"
              className="chatbot-avatar"
            />
          </button>
          <ChatbotExamEvaluation
            open={chatbotOpen}
            setOpen={setChatbotOpen}
            student_exam_id={student_exam_id}
          />

          {/* Buttons below */}
          {/* <Box
            sx={{
              mt: 3,
              mb: 3,
              p: "20px",
              bgcolor: "#fff",
              borderRadius: "20px",
              display: "flex",
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.04)",
              background: "white",
              flexDirection: isMobile ? "column" : "row",
              gap: 2,
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Button
              variant="outlined"
              startIcon={<ChatIcon />}
              sx={{
                flex: 1,
                fontWeight: 500,
                fontSize: "18px",
                borderRadius: "12px",
                // py: 1.2,
                padding: "6px",
                textTransform: "none",
                borderColor: "#2196f3",
                color: "#2196f3",
                "&:hover": {
                  borderColor: "#1976d2",
                  backgroundColor: "#e3f2fd",
                },
              }}
              onClick={() => {
                navigate("/feedback", { state: review_id }); // Replace with your target route
              }}
            >
              Proceed to Feedback
            </Button>

            <Button
              variant="contained"
              startIcon={<VisibilityIcon />}
              sx={{
                flex: 1,
                fontWeight: 500,
                fontSize: "18px",
                backgroundColor: "#009dff",
                borderRadius: "12px",
                // py: 1.2,
                padding: "6px",
                color: "white",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#0288d1",
                },
              }}
              onClick={() => {
                dispatch(clearListReViewExamID());
                navigate("/reviewexam", { state: review_id });
              }}
            >
              View Solutions
            </Button>
          </Box> */}
        </>
      )}

      <CustomSnackBox>
        {(showAlert) => (
          <SnackTriggerHandler
            showAlert={showAlert}
            showSubmitAlert={showSubmitAlert}
            setShowSubmitAlert={setShowSubmitAlert}
          />
        )}
      </CustomSnackBox>
    </>
  );
};

export default ExamResult;
